export default __webpack_public_path__ + "static/media/c.c417f91d.png";